import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=2965d2d1"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2965d2d1')) {
      api.createRecord('2965d2d1', component.options)
    } else {
      api.reload('2965d2d1', component.options)
    }
    module.hot.accept("./Badge.vue?vue&type=template&id=2965d2d1", function () {
      api.rerender('2965d2d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/user/components/Badge.vue"
export default component.exports